import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Paper, Grid, Divider, Typography, Tooltip } from '@mui/material';
import RatingStars from '../RatingStars';
import { useStyles } from './styles';
import useRoles from 'hooks/useRoles';
import { byFips } from 'country-code-lookup';

const Props = {
  feedback: PropTypes.shape({
    score: PropTypes.string.isRequired,
    reason: PropTypes.string,
    date: PropTypes.string.isRequired,
    user: PropTypes.shape({
      name: PropTypes.string,
      institution: PropTypes.string,
    }),
  }),
};

export default function Card({ feedback }) {
  const classes = useStyles();
  const roles = useRoles();
  const role = roles.find((userRole) => userRole.id === feedback.user.role);

  function showMoreInfoFroUser({ feedback, role }) {
    const country = feedback.user?.countryCode ? byFips(feedback.user.countryCode) : null;

    if (feedback.user.institution && country?.country && feedback.user.role) {
      return role && role.role ? (
        <Typography variant="body2">
          {role.role} at {feedback.user.institution} / {country?.country}
        </Typography>
      ) : null;
    }

    if (feedback.user.institution && country?.country) {
      return feedback.user.institution ? (
        <Typography variant="body2">
          {feedback.user.institution} / {country.country}
        </Typography>
      ) : null;
    }

    if (feedback.user.institution && feedback.user.role) {
      return role && role.role ? (
        <Typography variant="body2">
          {role.role} at {feedback.user.institution}
        </Typography>
      ) : null;
    }

    return role && role.role ? (
      <Typography variant="body2">
        {role.role} / {country?.country}
      </Typography>
    ) : null;
  }

  return (
    <Paper className={classes.root} elevation={0} variant="outlined">
      {!!feedback.reason && (
        <>
          <Typography>"{feedback.reason}"</Typography>

          <Divider className={classes.divider} />
        </>
      )}

      <Grid container={true}>
        <Grid item={true} xs={7}>
          <Tooltip
            classes={{ tooltip: classes.tooltip }}
            title={feedback.user.name || 'User'}
            placement="bottom-start"
          >
            <Typography className={classes.overflowText} gutterBottom={true}>
              <b>{feedback.user.name || 'User'}</b>
            </Typography>
          </Tooltip>
        </Grid>

        <Grid container={true} xs={5} justifyContent="flex-end">
          <RatingStars value={Math.ceil(Number(feedback.score) / 2)} />
        </Grid>
      </Grid>

      <Box width="100%" display="flex" justifyContent="space-between">
        <Box maxWidth="260px">{showMoreInfoFroUser({ feedback: feedback, role: role })}</Box>

        <Box mt={1}>
          <Typography variant="body2">{moment(feedback.date).format('DD/MM/YYYY')}</Typography>
        </Box>
      </Box>
    </Paper>
  );
}

Card.propTypes = Props;
